export default __webpack_public_path__ + "static/media/sprite.bab706ff.webp";